<template>
    <div class="row">
        <div class="col-xs-12 col-lg-6">
            <h2>Kunden-Login</h2>
            <p>Melden Sie sich an, indem Sie Ihre Lizenz-Datei hochladen.<br/>
              Die Lizenz haben Sie von uns per Mail erhalten.</p>

            <form v-on:submit="uploadFile(); event.preventDefault()">
                <div class="alert alert-danger" v-if="hadError && !ajaxActive">
                  <div>
                    Die Lizenzdatei war Fehlerhaft. Bitte versuchen Sie es erneut.
                  </div>
                </div>
                <div style="margin-top:2rem" v-if="!ajaxActive">
                <label class="btn" for="file">Lizenzdatei hochladen</label>
                <input type="file" ref="file" id="file" style="visibility:hidden; opacity:0; z-index:-1; position:absolute" v-on:change="uploadFile()">
                </div>
                <p v-else>
                    <span class="fa fa-spin fa-spinner"></span>
                    Lizenz wird geprüft
                </p>
            </form>
        </div>
    </div>
</template>

<script>
/*
    Sends a loggedIn-Event with the license data on successful login.
*/
export default {
  props: ["licToolRoot"],
  data() {
    return {
      licenseFile: [],
      hadError: false,
      ajaxActive: false
    };
  },
  methods: {
    uploadFile() {
      let files = this.$refs.file.files;
      if (files.length < 1) {
        return;
      }
      this.ajaxActive = true;
      let formData = new FormData();
      formData.append('license', files[0], files[0].name);
      this.$http.post(this.licToolRoot + '/customer/key4license.json', formData).then(response => {
          if (!response.body.data.licenseKey) {
              throw "License key missing";
          }
          this.$emit("login", response.body.data);
          this.ajaxActive = false;
      }).catch(error => {
          this.hadError = true;
          this.ajaxActive = false;
      });
    }
  }
};
</script>
